import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {PlatformService} from '../../../services/platform/platform.service';
import {CommonModule} from '@angular/common';
import {CultureItemComponent} from '../../../components/learning/culture-item/culture-item.component';
import {SpinnerComponent} from '../../../components/spinner/spinner.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-games-level-cultures',
  standalone: true,
  imports: [
    CommonModule,
    CultureItemComponent,
    SpinnerComponent,
    TranslateModule
  ],
  templateUrl: './games-level-cultures.component.html',
  styleUrls: ['./games-level-cultures.component.scss']
})
export class GamesLevelCulturesComponent implements OnInit {

  @Input() level: any;
  @Input() cultures: any;

  loader = true;
  currentTab: number;

  constructor(
    private activeModal: NgbActiveModal,
    public platformSrv: PlatformService
  ) {
  }

  async ngOnInit() {
    // this.currentTab = this.lessons[0].id;
    this.loader = false;
  }

  trackById(index: number, item: any) { return item.id; }

  close() {
    this.activeModal.close();
  }

  isActiveTab(lessonId: number): boolean {
    return this.currentTab === lessonId;
  }

  toggleTab(lessonId: number) {
    this.currentTab = lessonId;
  }

}
